module.exports = {
  A: " #64F73F",
  C: " #FFB340",
  G: " #EB413C",
  T: " #3C88EE",
  U: " #3C88EE"
};



// WEBPACK FOOTER //
// ./~/msa-colorschemes/src/nucleotide.js